module.exports = __webpack_public_path__ + "img/edge.06c7aa18.svg";